import { computed } from 'vue'
import { useUserStore } from '@/store/userData'

export default function useDisableModule() {
  const userStore = useUserStore()

  const lowerDisableModuleSet = computed(() => {
    const result: Set<string> = new Set()
    if (userStore.activeCatalog && userStore.activeCatalog.Config.DisableModules.length) {
      userStore.activeCatalog.Config.DisableModules.forEach(module => result.add(module.trim().toLowerCase()))
    }
    return result
  })

  const isResourcesModuleEnabled = computed(() => userStore.activeCatalog ? !lowerDisableModuleSet.value.has('resources') : false)
  const isOrderModuleEnabled = computed(() => userStore.activeCatalog ? !lowerDisableModuleSet.value.has('order') : false)
  const isForecastModuleEnabled = computed(() => userStore.activeCatalog ? !lowerDisableModuleSet.value.has('forecast') : false)
  const isDigitalAssetsEnabled = computed(() => userStore.activeCatalog ? !lowerDisableModuleSet.value.has('digitalassets') : false)

  return {
    isResourcesModuleEnabled,
    isOrderModuleEnabled,
    isForecastModuleEnabled,
    isDigitalAssetsEnabled,
  }
}
